import { isLocationCity } from '@/domain/location/useCases/isLocationCity'
import { isLocationInUnitedStates } from '@/domain/location/useCases/isLocationInUnitedStates'
import { Location } from '@/types/models/Location.model'
import { isNil } from '@/utils/checks'
import { stateNameToCode } from '@/utils/stateCode'

export const TITLE_PREFIX = 'Best Drug & Alcohol Rehab Centers'
export const US_SUFFIX = '(Insurance & Cost)'
export const INTERNATIONAL_SUFFIX = '(With Pricing)'

interface GenerateLocationPageTitle {
  (props: { location?: Location; year: number }): string
}

const generateLocationPageTitle: GenerateLocationPageTitle = ({
  location,
  year
}) => {
  if (isNil(location)) {
    return `${TITLE_PREFIX} ${year} ${INTERNATIONAL_SUFFIX}`
  }

  const { title, parentLocation } = location

  const titleSubfix = isLocationInUnitedStates(location)
    ? US_SUFFIX
    : INTERNATIONAL_SUFFIX

  const stateAbbreviation = stateNameToCode[parentLocation as string]

  const parentLocationForTitle = stateAbbreviation
    ? stateAbbreviation
    : location?.parentLocation

  const locationWithParent = isLocationCity(location)
    ? `${title}, ${parentLocationForTitle}`
    : title

  return `${TITLE_PREFIX} in ${locationWithParent} ${year} ${titleSubfix}`
}

export default generateLocationPageTitle
